<template>
<div class="chapter">
<div class="inner_page">
<div id="part1">
<a id="page_7">
</a><p class="booksubtitle" id="pt1" style="margin-top:5em!important;"><a id="page_7"></a><a href="#/text/05_toc#pt1">Building the Privateer</a></p>
<p class="booktitle" style="margin-bottom:1em!important;"><a href="#/text/05_toc#pt1"><big><em>Prince de Neufchatel</em></big></a></p>
<div class="image-wrap">
<div class="image">
<img alt="image" src="images/fm-2.jpg" style="max-width:100%"/>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_part1.vue?30b9f2e3